import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'
import Utilities from '@/plugins/Utilities.js'
import logoutOnUnauthorized from "../logout";
const ENDPOINT_PATH = process.env.VUE_APP_BASE;

export default{
  user: {
    authenticated: false,
    isSuper: false,
    isAdmin: false,
    isUser: false
  },
  api: {
    endpointPath: ENDPOINT_PATH,
    roleBasePath: ''
  },

  register (name, lastname, username, email, password) {
    const user = { name, lastname, username, email, password }

    return axios.post(ENDPOINT_PATH + 'users/register', user).catch(logoutOnUnauthorized)
  },
  login (_email, _password) {
    const user = { _email, _password }

    return axios.post(ENDPOINT_PATH + 'login_check', user).catch(logoutOnUnauthorized)
  },
  logout () {
    sessionStorage.clear()
    this.user.authenticated = false
    // redirect('/')
  },
  markAsLogged (id) {
    const token = sessionStorage.getItem('token')
    axios.defaults.headers.common.Authorization = 'Bearer ' + token
    this.getUserData(token,id)
    this.user.authenticated = true
  },
  getUserData (token, id) {
    const decodedToken = VueJwtDecode.decode(token)

    sessionStorage.setItem("user", decodedToken.username)
    sessionStorage.setItem("user_id", id)

    sessionStorage.setItem("user_hash", Utilities.generateHash(id))
    this.roles = decodedToken.roles
    decodedToken.roles.forEach(role => {
      if (role === 'ROLE_ADMIN') {
        this.user.isSuper = true
        this.api.roleBasePath = '/superadmin'
        sessionStorage.setItem("user_rol", 'admin')
      }
      if (role === 'ROLE_USER') {
        this.user.isAdmin = true
        this.api.roleBasePath = '/admin'
        sessionStorage.setItem("user_rol", 'user')
      }
    })
  },
  isAuthenticated () {
    return this.user.authenticated
  }

}
